import { Injectable } from "@angular/core";
import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Author } from "./authors.type";

@Injectable({
  providedIn: "root",
})
export class CustomvalidationService {
  patternValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      let arrayAuthorsActives = control.value.authors.filter(
        (el: Author) => el.active == true,
      );
      let valueAuthors = arrayAuthorsActives.length - 3;

      return arrayAuthorsActives.length <= 3
        ? null
        : {
            maxAuthorsValidated: true,
            numberAuthors: valueAuthors <= 0 ? 0 : valueAuthors,
            stringAuthor: valueAuthors == 1 ? "author" : "autores",
          };
    };
  }

  cpfValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const cpf = control.value.replace(/[\s.-]*/gim, "");

      if (cpf.length !== 11) {
        return { invalidCpf: true };
      }

      if (/^(\d)\1{10}$/.test(cpf)) {
        return { invalidCpf: true };
      }

      const calculateVerifier = (
        cpf: string,
        isSecondVerifier: boolean,
      ): number => {
        const digits = cpf.split("").map(Number);
        const weight = isSecondVerifier
          ? [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]
          : [10, 9, 8, 7, 6, 5, 4, 3, 2];

        const sum = digits
          .slice(0, isSecondVerifier ? 10 : 9)
          .reduce((acc, digit, idx) => acc + digit * weight[idx], 0);

        const remainder = sum % 11;
        return remainder < 2 ? 0 : 11 - remainder;
      };

      const firstVerifier = calculateVerifier(cpf.slice(0, 9), false);
      const secondVerifier = calculateVerifier(cpf.slice(0, 10), true);

      if (
        firstVerifier !== parseInt(cpf[9], 10) ||
        secondVerifier !== parseInt(cpf[10], 10)
      ) {
        return { invalidCpf: true };
      }

      return null;
    };
  }
}
